let ownershipTransferToken = "";
let passwordResetToken = "";

export function storeOwnershipTransferToken(value) {
  const candidate = typeof value === "string" ? value.trim() : "";
  ownershipTransferToken = /^[a-f0-9]{64}$/i.test(candidate) ? candidate : "";
}

export function consumeOwnershipTransferToken() {
  const token = ownershipTransferToken;
  ownershipTransferToken = "";
  return token;
}

export function storePasswordResetToken(value) {
  const candidate = typeof value === "string" ? value.trim() : "";
  passwordResetToken = /^(?:[a-f0-9]{32}|[a-f0-9]{40})$/i.test(candidate)
    ? candidate
    : "";
}

export function consumePasswordResetToken() {
  const token = passwordResetToken;
  passwordResetToken = "";
  return token;
}

function consumeBootstrapProperty(propertyName, store) {
  if (typeof window === "undefined") return;
  store(window[propertyName]);
  try {
    delete window[propertyName];
  } catch {
    window[propertyName] = "";
  }
}

consumeBootstrapProperty(
  "__rmeOwnershipTransferBootstrapToken",
  storeOwnershipTransferToken
);
consumeBootstrapProperty(
  "__rmePasswordResetBootstrapToken",
  storePasswordResetToken
);
